import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import { getTodaysData } from "../../../common/Validations";
import TermsConditions from "../../customer_app/Customer_V5/Equipment/TermsConditions";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import toast from "react-hot-toast";
import ItemService from "../../../services/supplier_appCommonService";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import SupplierConstants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";

const MatrialCreatePoShopwise = React.forwardRef((props, ref) => {
  const [editorContent, setEditorContent] = useState("");
  const [isCardVisible10, setCardVisible10] = useState(true);
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const navigate = useNavigate();

  const [isCardVisible2, setCardVisible2] = useState(true);
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const hideModal = () => {
    setModalShowAddProduct(false);
  };
  const [formInputs, setFormInputs] = useState({
    // purchasingDocumentType: "LOC - Local Purchase Doc",
    requestDate: getTodaysData() || "",
    statusHeader: "PR Created",
    purchaseType: "MAT - Material",
    companyCode: "",
    email: "",
    phone: "",
    vendorAddress: "Byyizzy Industrial Area,Bengaluru",
    // initiatorName: "TECHNICAL",
    // initiator: "TECH001",
    purchasingReqDocumentType: "LOC - Local Purchase Doc",
    purchasingReqDocumentCode: "LOC",
    prStatusHeader: "PR Created",
    currency: "INR-Rupee",
    version: "V0",
    purchasingReqDocumentValue: "",
    purchasingReqRemark: "",
    purchasingGroup: "",
  });

  const qrValue = formInputs?.info?.[0]?.materialCode || "NO_CODE";
  const [disabled, setDisabled] = useState(false);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");
  const [itemAmountValue, setItemAmountValue] = useState(0);

  const [taxAmountValue, setTaxAmountValue] = useState(0);
  const [subTotalValue, setSubTotalValue] = useState(0);

  useEffect(() => {
    const items = formInputs?.info || [];

    const itemTotal = items.reduce(
      (sum, item) => sum + Number(item.netValue || 0),
      0,
    );

    const taxTotal = items.reduce(
      (sum, item) => sum + Number(item.taxAmount || 0),
      0,
    );

    setItemAmountValue(itemTotal);
    setTaxAmountValue(taxTotal);
    setSubTotalValue(itemTotal + taxTotal);
  }, [formInputs?.info]);

  const incotermsData = [
    { name: "UN - Not Free", code: "EXW" },
    { name: "DE - Delivered ex quay (duty paid)", code: "EXW" },
  ];

  const paymentTermsData = [
    { name: "30GR - 30 Days From GRN date", code: "30GR" },
    { name: "60GR - 60 Days From GRN date", code: "60GR" },
    { name: "90GR - 90 Days From GRN date", code: "90GR" },
    { name: "180GR - 180 Days From GRN date", code: "180GR" },
  ];

  useEffect(() => {
    setINCOTerms(incotermsData);
    setpaymentTerm(paymentTermsData);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      !getDropdownData ||
      !getDropdownData.textField ||
      !getDropdownData.textCode
    )
      return;

    setFormInputs((prev) => {
      if (
        prev[getDropdownData.textField] === getDropdownData.name &&
        prev[getDropdownData.textCode] === getDropdownData.code
      ) {
        return prev; // ✅ no re-render
      }

      return {
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
        [getDropdownData.textCode]: getDropdownData.code,
      };
    });
  }, [getDropdownData]);

  //Validations
  // eslint-disable-next-line
  const [validation, setValidation] = useState({});
  const handleInputChange = (rowId, event, valueType = "text") => {
    if (!event?.target) return;

    const { name, value } = event.target;

    setFormInputs((prev) => {
      const updatedInfo = prev.info.map((row) => {
        if (row.local_id !== rowId) return row;

        let updatedRow = { ...row };

        // Allow empty + zero while typing
        if (valueType === "Number") {
          updatedRow[name] = value;
        } else {
          updatedRow[name] = value;
        }

        const qty = Number(updatedRow.purchaseQuantity);
        const price = Number(updatedRow.orderPriceUnit);
        const taxPercent = Number(updatedRow.taxCode || 0);

        if (!isNaN(qty) && qty >= 0) {
          updatedRow.netValue = qty * price;
          updatedRow.taxAmount = (updatedRow.netValue * taxPercent) / 100;
        } else {
          updatedRow.netValue = 0;
          updatedRow.taxAmount = 0;
        }

        return updatedRow;
      });

      return { ...prev, info: updatedInfo };
    });
  };

  const handleBasicInputChange = (event) => {
    const { name, value } = event.target;

    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  useEffect(() => {
    if (!props.openFromCart) return;
    if (!props.cartItems || props.cartItems.length === 0) return;

    const lineItems = props.cartItems.map((product, index) => {
      const qty = Number(product.qty) || 1;
      const price = Number(product.price) || 0;

      return {
        local_id: Date.now() + index,

        materialCode: product.productNumber || "",
        materialDescription: product.productName || "",
        materialGroup: product.category || "",
        warranty: product.warranty || "",
        purchasingGroup: product.category || "",
        purchaseQuantity: qty,
        orderUnitOfMeasure: product.uom,

        orderPriceUnit: price,
        netValue: qty * price,

        currencyCode: "INR",
        taxCode: 2,
        taxAmount: (qty * price * 2) / 100,

        deliveryDate: "",
        plant: "",
        storageLocn: "",
      };
    });
    const productNames = props.cartItems
      .map((item) => item.productName)
      .filter(Boolean)
      .join(", ");

    const vendorNames = props.cartItems
      .map((item) => item.vendor)
      .filter(Boolean)
      .join(", ");

    const categories = [
      ...new Set(props.cartItems.map((item) => item.category).filter(Boolean)),
    ].join(", ");

    const images = props.cartItems.map((item) => item.imageUrl).filter(Boolean);

    setFormInputs((prev) => ({
      ...prev,
      productName: productNames,
      vendor: vendorNames,
      category: categories,
      imageUrl: images,
      info: lineItems,
      purchasingGroup: categories,
    }));
  }, [props.openFromCart, props.cartItems]);

  useEffect(() => {
    if (props.openFromCart) return; // ❗ skip cart mode
    if (!props.equipmentData) return;

    const product = props.equipmentData;

    const lineItem = {
      local_id: Date.now(),

      materialCode: product.productNumber || "",
      materialDescription: product.productName || "",
      materialGroup: product.category || "",
      warranty: product.warranty || "",
      purchasingGroup: product.category || "",

      purchaseQuantity: 1,
      orderUnitOfMeasure: product.uom || "EA",

      orderPriceUnit: Number(product.price) || 0,
      netValue: Number(product.price) || 0,

      currencyCode: "INR",
      taxCode: 2,
      taxAmount: ((Number(product.price) || 0) * 2) / 100,

      deliveryDate: "",
      plant: "",
      storageLocn: "",
    };

    setFormInputs((prev) => ({
      ...prev,
      productName: product.productName || "",
      vendor: product.vendor || "",
      category: product.category || "",
      imageUrl: product.imageUrl ? [product.imageUrl] : [],
      purchasingGroup: product.category || "",
      info: [lineItem],
    }));
  }, [props.equipmentData, props.openFromCart]);

  const resetForm = () => {
    setFormInputs((prev) => ({
      ...prev,
      companyCode: "",
      email: "",
      phone: "",
      purchasingReqRemark: "",
      paymentTerms: "",
      incoTerms: "",
    }));

    setEditorContent("");
    setDisabled(false);
  };

  useEffect(() => {
    if (!props.show) resetForm();
  }, [props.show]);

  const handleSave = async () => {
    const { info, ...restFormInputs } = formInputs;

    const payload = {
      ...restFormInputs,
      purchasingReqDocumentValue: itemAmountValue,
      purchasingReqTaxValue: taxAmountValue,
      purchasingReqSubTValue: subTotalValue,

      items: (info || []).map((row, index) => ({
        local_id: index + 1,
        purchasingReqDocumentItemNr: index + 1,
        materialCode: row.materialCode,
        materialDescription: row.materialDescription,
        materialGroup: row.materialGroup,
        purchaseQuantity: row.purchaseQuantity,
        orderUnitOfMeasure: row.orderUnitOfMeasure,
        orderPriceUnit: row.orderPriceUnit,
        netValue: row.netValue,
        currencyCode: row.currencyCode,
        taxCode: row.taxCode,
        deliveryDate: row.deliveryDate,
        plant: row.plant,
        storageLocn: row.storageLocn,
      })),
    };

    const obj = {
      data: payload,
    };
    try {
      const item = await ItemService.addPR(obj);

      if (item?.status === 200) {
        toast.success("PR created successfully", {
          position: "top-right",
        });
        localStorage.removeItem("material_cart");
        props.onHide();
        navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong", {
        position: "top-right",
      });
    }

    setDisabled(false);
  };

  let POLineItemInitialCol = [
    {
      name: "Item Nr",
      cell: (row, index) => index + 1,
      width: "80px",
    },

    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <span>
          {row.materialCode || "--"} – {row.materialDescription || "--"}
        </span>
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Description",
    //   selector: (row) => row.materialDescription || "--",
    //   cell: (row) => (
    //     <TextAreaField
    //       className="inputBox mt-1"
    //       name="materialDescription"
    //       placeholder=""
    //       value={row.materialDescription || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => <span>{row.materialGroup || "--"}</span>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="number"
          name="purchaseQuantity"
          value={row.purchaseQuantity ?? ""}
          onChange={(e) => handleInputChange(row.local_id, e, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "UOM",
    //   selector: (row) => row.orderUnitOfMeasure || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       name="orderUnitOfMeasure"
    //       placeholder=""
    //       value={row.orderUnitOfMeasure || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   width: "200px",
    // },
    {
      name: "UOM",
      selector: (row) => row.orderUnitOfMeasure,
      width: "80px",
    },
    // {
    //   name: "Warranty",
    //   selector: (row) => row.warranty || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       // label="Please Enter the Remarks*"
    //       name="warranty"
    //       placeholder=""
    //       value={row.warranty || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },

    {
      name: "Warranty",
      selector: (row) => row.warranty,
      width: "150px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Purchase Request
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*Equipment informatio */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PR</span>
                </Col>
                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Purchase Request</span>
                  <span className="subHeaderTitle"> Purchase Request</span>
                </Col>
              </Row>
            </h2>
            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="requestDate"
                            className="inputBox"
                            label="Date"
                            name="requestDate"
                            placeholder=""
                            type="date"
                            value={formInputs.requestDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor"
                            placeholder=""
                            name="vendor"
                            id="vendor"
                            error={validation.vendor || ""}
                            value={formInputs?.vendor || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor Address"
                            placeholder=""
                            name="vendorAddress"
                            id="vendorAddress"
                            error={validation.vendorAddress || ""}
                            value={formInputs?.vendorAddress || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Purchase Type"
                            name="purchaseType"
                            value={formInputs.purchaseType}
                            disabled
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Category"
                            placeholder=""
                            name="category"
                            id="category"
                            error={validation.category || ""}
                            value={formInputs?.category || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Purchase Req Remarks"
                            placeholder=""
                            name="purchasingReqRemark"
                            id="purchasingReqRemark"
                            error={validation.purchasingReqRemark || ""}
                            value={formInputs?.purchasingReqRemark || ""}
                            onChange={handleBasicInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Payment Terms"
                            extraLabel=""
                            placeholder=""
                            data={getpaymentTerm}
                            id="paymentTerms"
                            iconClassName="dropdownIcon"
                            name="paymentTerms"
                            code="paymentTermsCode"
                            setValue={formInputs?.paymentTerms || []}
                            getvalue={setDropdownData}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="INCOTerms"
                            extraLabel="INCOTerms Code"
                            placeholder=""
                            data={getINCOTerms}
                            id="incoTerms"
                            iconClassName="dropdownIcon"
                            name="incoTerms"
                            code="incoTermsCode"
                            setValue={formInputs?.incoTerms || []}
                            getvalue={setDropdownData}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Basic Information */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BI</span>
                </Col>
                <Col xs={12} md={6} lg={7}>
                  <span className="headerTitle">Basic Information</span>
                  <span className="subHeaderTitle">Basic Information</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            ></div>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="accordion-body">
                  <Row className="pt-2 pb-4">
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Company Name/Name"
                        placeholder=""
                        name="companyCode"
                        id="companyCode"
                        error={validation.companyCode || ""}
                        value={formInputs?.companyCode || ""}
                        onChange={handleBasicInputChange}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Email"
                        placeholder=""
                        name="email"
                        id="email"
                        error={validation.email || ""}
                        value={formInputs?.email || ""}
                        onChange={handleBasicInputChange}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Phone"
                        placeholder=""
                        name="phone"
                        id="phone"
                        error={validation.phone || ""}
                        value={formInputs?.phone || ""}
                        onChange={handleBasicInputChange}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Service Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>
                <Col xs={12} md={6} lg={7}>
                  <span className="headerTitle">Product Details</span>
                  <span className="subHeaderTitle">Product Details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      // title=""
                      columns={POLineItemInitialCol}
                      data={formInputs?.info || []}
                      keyField="local_id"
                      // progressPending={loading}
                      // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      // pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      selectableRows
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility10}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">I</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">Instructions</span>
                  <span className="subHeaderTitle">Instructions Section</span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible10 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="p-4">
                  <Col xs={12} md={12} lg={12}>
                    <RichTextEditor
                      value={editorContent}
                      onChange={handleEditorChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <p className="commLeftRightPadding fw-bold">Product Image</p>
        <div className="po-image-list">
          {Array.isArray(formInputs.imageUrl) &&
            formInputs.imageUrl.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="product"
                className="po-product-img"
              />
            ))}
            <QRCode value={qrValue} size={90} />
        </div>
        <col xs={12} md={2} lg={2}></col>
        <Col xs={12} md={2} lg={2} className="ms-auto text-end">
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>

        <TermsConditions show={modalShowAddProduct} onHide={hideModal} />
      </Modal.Body>
    </Modal>
  );
});

export default MatrialCreatePoShopwise;
